import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as TrashIcon } from '../../../../assets/images/trashcanIcon.svg';
import Button from '../../../../components/shared/Button/Button';
import Modal from '../../../../components/shared/Modal/Modal.jsx';
import { IsMobile } from '../../../../helpers/IsMobile';

import styles from './DeleteModal.module.scss';

const DeleteModal = ({ showModal, handleDeleteYes, handleToggleDeleteModal, content }) => {
  const { t } = useTranslation('common');
  const isMobile = IsMobile();
  return (
    <Modal
      show={showModal}
      onHide={handleToggleDeleteModal}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      fullscreen={isMobile}
    >
      <Modal.CustomHeader closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{t('modals.areYouSure')}</Modal.Title>
      </Modal.CustomHeader>
      <Modal.Body>
        <div className={styles.editorCont}>
          <span className={styles.trashIcon}>
            <TrashIcon />
          </span>
          <p className={styles.confirmationText}>{t('modals.confirmDeleteContact', { content })}</p>
        </div>
      </Modal.Body>
      <Modal.CustomFooter>
        <Button variant="outline-primary" onClick={handleDeleteYes} className={styles.yesNoBtn}>
          {t('yes')}
        </Button>
        <Button variant="primary" onClick={handleToggleDeleteModal} className={styles.yesNoBtn}>
          {t('no')}
        </Button>
      </Modal.CustomFooter>
    </Modal>
  );
};

export default DeleteModal;
